import {createContext} from 'react'
import {LogoutModalHandler} from 'types'

export const LogoutModalContext = createContext<LogoutModalHandler | undefined>(
  undefined,
)
